'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ensureFSAMiddleware;

var _fluxStandardAction = require('flux-standard-action');

function ensureFSAMiddleware() {
  var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var ignore = _ref.ignore;

  return function () {
    return function (next) {
      return function (action) {
        if (typeof ignore === 'function' && ignore(action)) {
          return next(action);
        }

        if (!(0, _fluxStandardAction.isFSA)(action)) {
          console.log(action); // eslint-disable-line
          throw new Error('Flux Standard Action Violation: Actions must only have type, payload, error, and/or meta properties.');
        }

        return next(action);
      };
    };
  };
}